"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sorano": {
    "f101f578": [{
      "hkey": "ceeeb170",
      "slug": "montebuono-appalto",
      "name": "Montebuono Appalto",
      "primary": true,
      "skipSearch": false
    }],
    "montebuono": [{
      "hkey": "ceeeb170",
      "slug": "montebuono-appalto",
      "name": "Montebuono Appalto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "68a7e945": [{
      "hkey": "953c1626",
      "slug": "sorano",
      "name": "Sorano",
      "primary": true,
      "skipSearch": false
    }],
    "montorio": [{
      "hkey": "953c1626",
      "slug": "sorano",
      "name": "Sorano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;